export default "__VITE_ASSET__0ee2e00b__"